import { Space,  Select, Button,  Table, Tooltip, Form, message, Divider, Popover } from 'antd';
import {  CheckOutlined, CloseOutlined,FileExcelOutlined } from '@ant-design/icons';
import { useState, useEffect, useContext } from 'react';
import Cookies from 'js-cookie';
import WebLinks from '../../api/WebLinks';
import constants from '../../constants/constants';
import APIUtils from '../../api/APIUtils';
import { useParams } from 'react-router-dom/cjs/react-router-dom';
import { GetCustomPriorityLevelIcons, GetPriorityLevelColors, downloadFiles, trackPageAccess } from '../../globalFunctions/GlobalFunctions';
import moment from 'moment';
import SmartScorecard from './SmartScorecard';
import { CommonContext } from '../../Context';

const { Option } = Select

const YourJobsApplications = (props) => {
  //Variable declaration
  const commonContext=useContext(CommonContext);
  const buyerId = commonContext.common.buyerId;
  const [dataSource, setDataSource] = useState([]);
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [priorityCheck,setPriorityCheck]=useState("f");
  const [suplierListLoader,setSuplierListLoader]= useState(false);
	const [allowedSupplierList, setAllowedSupplierList] = useState([]);
  const [supplierids,setSupplierIds]= useState("");
  const { jobId } = useParams();

  //Function on page load
  useEffect(() => {
    getAllowedSuppliers();
    getBuyerPrioritylist();
    fetchYourJobsApplicationLogList(null);
    trackPageAccess(buyerId,window.location.href)
  }, []);

	//Function to get Allowed suppliers list
	const getAllowedSuppliers =async()=>{
		setSuplierListLoader(true);
		const response = await APIUtils.apiCall('GET',WebLinks.GetALlAllowedSuppliers);
		if(!response.isCatch && response.resultObj.statusCode==="2000"){
			setAllowedSupplierList(response?.resultObj?.data||[])
			setSuplierListLoader(false);
		}else{
			setAllowedSupplierList([]);
			setSuplierListLoader(false);
			message.error(response.resultObj.message);
		}
	}
  //Function to get priority list
  const getBuyerPrioritylist=async()=>{
    let url = WebLinks.GetBuyerPriorityFilters + buyerId;    
    const response = await APIUtils.apiCall('GET', url);
    if (!response.isCatch && response.resultObj) {
      let temppriorityColorCode=[];
      setPriorityCheck(response?.resultObj?.data?.length>5?"t":"f");
      response?.resultObj?.data.forEach(element => {
        let priorityObj={
          value:element.priorityLevel.toString(),
          colorValue:response?.resultObj?.data?.length>5?GetCustomPriorityLevelIcons(element.priorityLevel):GetPriorityLevelColors(element.priorityLevel),
          customName:element.customName,
        }
        temppriorityColorCode.push(priorityObj);
      });
    } else {
      message.error(response?.resultObj?.message);
    }
  };
  // Table columns
  const yourJobsColumns = [
    {
      title: 'Active',
      key: 'active',
      dataIndex: 'active',
      align: 'center',
      sorter: (a, b) => (a.active === b.active ? 0 : a.active ? 1 : -1),
      render: (_, record) =>
        record.active === true ? (
          <Button
            icon={<CheckOutlined className="text-xl text-lime-500" />}
            type="text"
            onClick={() => changeActive(record.id, record.active)}
          />
        ) : (
          <Button
            icon={<CloseOutlined className="text-xl text-lime-500" style={{ color: "red" }} />}
            type="text"
            onClick={() => changeActive(record.id, record.active)}
          />
        ),
    },
    {
      title: 'Created On',
      dataIndex: 'createdOn',
      key: 'createdOn',
      width: '12%',
      render: (createdOn) => {
           {return<span className='whitespace-nowrap'><p>{moment(createdOn).format('YYYY-MM-D')}</p><p>{moment(createdOn).format('h:mm a')}</p></span>}
      },
      sorter: (a, b) => moment(a.createdOn).unix() - moment(b.createdOn).unix(),
  },
    {
      title: 'Priority',
      dataIndex: 'priority',
      key: 'priority',
      sorter: (a, b) => a.priority - b.priority,
      align: "center",
      render: (text,element) => <Space>
          <div className={priorityCheck==="t"?GetCustomPriorityLevelIcons(element.priority):GetPriorityLevelColors(element.priority)}></div>
				</Space>
    },
    {
      title: 'Supplier',
      dataIndex: 'supplierName',
      key: 'supplierName',
      sorter: (a, b) => a.supplierName.localeCompare(b.supplierName),
    },
    {
      title: 'GAP',
      align: 'center',
      width: '7%',
      dataIndex: 'gapOverallScore',
      key: 'GAPOverAllScore',
      sorter: (a, b) => (a?.gapOverallScore ?? 0) - (b?.gapOverallScore ?? 0),

      render: (value, record) => {
        if (!value) {
          return '-';
        }
        return (
          <Popover
            placement="right"
            autoAdjustOverflow
            destroyTooltipOnHide
            overlayStyle={{
              maxWidth: '90vw',
              width: '750px',
            }}
            content={
              <div
                style={{
                  maxHeight: '90vh',
                  overflowY: 'auto',
                  overflowX: 'auto',
                }}
              >
                <SmartScorecard
                  json={record?.breakdown || {}}
                  firstName={record?.userFirstName}
                  lastName={record?.userLastName}
                />
              </div>
            }
            trigger="hover"
          >
            <span className="cursor-pointer text-blue-500">
              {value || "-"}
            </span>
          </Popover>
        );
      },
    },
    {
      title: 'Job Title',
      dataIndex: 'title',
      key: 'jobTitle',
      sorter: (a, b) => a.title.localeCompare(b.title),
    },
    {
      title: 'Location',
      dataIndex: 'place',
      key: 'place',
      sorter: (a, b) => a.place.localeCompare(b.place),
    },
    {
      title: 'Reference',
      dataIndex: 'reference',
      key: 'reference',
      sorter: (a, b) => {
        const referenceA = parseInt(a.reference.match(/\d+/)[0], 10);
        const referenceB = parseInt(b.reference.match(/\d+/)[0], 10);

        return referenceA - referenceB;
      },
    },
  {
    title: 'Name',
    dataIndex: 'userFirstName',
    key: 'userFirstName',
    hidden:  !(Cookies.get(constants.COOKIE_CANDIDATE_TAB) === "false" || Cookies.get(constants.COOKIE_CANDIDATE_TAB) === false || Cookies.get(constants.COOKIE_IS_ADMIN) === "true" || Cookies.get(constants.COOKIE_IS_ADMIN) === true),
    sorter: (a, b) => a.userFirstName.localeCompare(b.userFirstName),
    render: (_, record) => (<>
      <div className='no-wrap'><Tooltip title={record.applyEmail}>{record.userFirstName+" "+record.userLastName}</Tooltip></div>
      <div className='whitespace-nowrap overflow-hidden text-ellipsis' >{record.telephone}</div>
  </>),
  },
    {
      title: 'Status Id',
      dataIndex: 'statusId',
      key: 'statusId',
      width: '10%',
      sorter: (a, b) => a.statusId - b.statusId,
      render: (_, record) => (<>
        <div>{record.appStatus? record.statusId+"-"+record.appStatus: record.statusId}</div>
    </>),
    },
    {
      title: 'Spend',
      dataIndex: 'spend',
      key: 'spend',
      sorter: (a, b) => a.spend - b.spend,
    },
  ];

  //Fetch the jobs upload history for the last 30 days 
  const fetchYourJobsApplicationLogList = async (supplierId=null) => {
    setIsLoading(true);
    let url = WebLinks.GetYourJobApplications + buyerId + "&jobId="+jobId;
    if(supplierId && supplierId.length>0){
      url += "&selectedSupplierId=" + supplierId;
    }
    const response = await APIUtils.apiCall('GET', url);
    if (!response.isCatch && response.resultObj) {
      setDataSource(response.resultObj.data);
      setCount(response.resultObj.getCount);
    } else {
      message.error(response.resultObj?.message);
    }
    setIsLoading(false);
  };

  //Function to change the Active button to cross or tick.
  const changeActive = async (rowKey, previousValue) => {
    let tbldata = [...dataSource];
    let index = tbldata.findIndex((row) => row.id === rowKey);
    if (index > -1) {
      if (tbldata[index].active === true) {
        tbldata[index].active = false;
      } else {
        tbldata[index].active = true;
      }
      setDataSource(tbldata);
    }
    //Api call to update in DB
    let activePayload = null;
    activePayload = {
      jobId: rowKey,
      active: !previousValue,
    }
    const activeResponse = await APIUtils.apiCall('PUT', WebLinks.PutActiveJob, JSON.stringify(activePayload));
    if (activeResponse.isCatch) {
      message.error(message.resultObj.message);
    }
  };

  //Function on change of supplier selection
	const handleSupplierSelect=(selectedSuppliers)=>{
		if(selectedSuppliers.length>0){
			let tempSelectedSuppliers=selectedSuppliers.filter(value => value !== 'showall');
			let selectedSuppliersFinal=tempSelectedSuppliers.length>0?tempSelectedSuppliers:"";
			form.setFieldsValue({
				supplierList:selectedSuppliersFinal
			})
      setSupplierIds(selectedSuppliersFinal);
      fetchYourJobsApplicationLogList(selectedSuppliersFinal);
		}else{
			form.setFieldsValue({
				supplierList:["showall"]
			})
      setSupplierIds("");
      fetchYourJobsApplicationLogList(null);
		}
	}
  //Download excel
	const downloadFile = () => {
		setIsLoading(true)
		let url=WebLinks.DownloadYourJobApplications+buyerId + "&jobId="+jobId
		if(supplierids.length>0){
			url= url+"&selectedSupplierId="+supplierids
		}
		downloadFiles(url,"YourJobApplications.xlsx");
		setTimeout(() => {
      setIsLoading(false)
		}, 3000);
	};
  return (
    <div>
      <div className="flex justify-between items-center gap-1">
        <Space>
          <div className="uppercase font-bold text-xl">Your Jobs Applications</div>
        </Space>
      </div>
      <Divider className="my-3" />
      <div className="flex flex-wrap justify-between items-center gap-1 mb-3">
        <Space wrap >
          <Form form={form} className='!w-full flex flex-wrap justify-between items-center gap-3 mb-3'>
            <label className='ml-2 mr-2'>Filter by Supplier</label>
            <Form.Item name="supplierList" className='mb-0'>
              <Select
                loading={suplierListLoader}
                className='!w-60'
                // value={selectedSupplier || []}
                placeholder={constants.supplierName}
                mode='multiple'
                allowClear
                defaultValue={"showall"}
                showSearch
              filterOption={(input, option) =>
                  option.props.value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                  option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
                onChange={(e) => handleSupplierSelect(e)}
                >
                  <Option key='showall' value='showall'>Show all</Option>
                    {allowedSupplierList?.map((supplier) => (
                      <Option key={supplier.supplierId}
                          value={supplier.supplierId}
                      >
                      {supplier.name}</Option>
                ))}
              </Select>
            </Form.Item>
            <Tooltip placement='right' title="Download as Excel">
								<Button
										className='bg-green-800 text-white hover:!text-white hover:!border-green-500'
										icon={<FileExcelOutlined />}
										onClick={()=>{downloadFile()}}
								>
									Download as Excel
								</Button>
								</Tooltip>
          </Form>
        </Space>
      </div>
      <div className="overflow-x-auto">
        <Table
          loading={isLoading}
          size='small'
          pagination={{
            showSizeChanger: true,
            pageSizeOptions: ["200", "500", "1000", "2000"],
            defaultPageSize: 200,
          }}
          columns={yourJobsColumns}
          dataSource={dataSource}
          footer={() =>dataSource?.length>0? `Showing 1 to ${Math.min(200, count)} of ${count} entries`:null}
        />
      </div>
    </div>
  );
};

export default YourJobsApplications;